module.exports = __webpack_public_path__ + "img/Sound Decision Maker.6b497f6f.svg";